import { formatApy } from "../../utils/functions/formatApy";
import { Emdash } from "../Punctuation";
import { GridPercentSign } from "./GridPercentSign";

// // // //

/**
 * DataGridPercentValue
 * Render a percent value in DataGridCell
 * ENHANCEMENT - we should have a more standarizd percentage dipslay function that's different from `formatApy`, which is *very* old at this point
 */
export function DataGridPercentValue(props: { value: number }) {
    const { value } = props;
    if (typeof value !== "number" || Number.isNaN(value)) {
        return <Emdash />;
    }

    if (value === 0) {
        return (
            <>
                {formatApy(value).toFixed(0)}
                <GridPercentSign />
            </>
        );
    }

    // Return non-comma formatted percent display for values lower than "1,000 percent"
    if (value < 10) {
        return (
            <>
                {formatApy(value).toFixed(2)}
                <GridPercentSign />
            </>
        );
    }

    // Return comma-formatted percent display for values greater-than-or-equal-10 "1,000 percent"
    const formattedApy = formatApy(value).toFixed(2);
    const split = formattedApy.split(".");
    const integerValue = split[0];
    const decimalValue = split[1];
    return (
        <>
            {parseInt(integerValue, 10).toLocaleString()}
            {"."}
            {decimalValue}
            <GridPercentSign />
        </>
    );
}
